var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"baseRadio",class:[{ active: _vm.value === _vm.id }, _vm.themeModel.theme],on:{"click":_vm.handleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }